import { Pipe, PipeTransform } from '@angular/core';
import { NotificationEmail } from '../../models/notificationEmail';

@Pipe({
	name: 'filterNotificationEmailByTitle'
})
export class FilterNotificationEmailByTitlePipe implements PipeTransform {
	transform(notificationEmail: NotificationEmail[], filter: string): NotificationEmail[] {
		if (
			!notificationEmail ||
			!filter ||
			notificationEmail === null ||
			filter === null ||
			filter === ''
		) {
			return notificationEmail;
		}

		return notificationEmail.filter((notificationEmail: NotificationEmail) => {
			if (notificationEmail.title) {
				// TODO: add lastTitle too
				return notificationEmail.title.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
